import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    Avatar,
    Button,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    makeStyles,
    OutlinedInput,
    TextField,
} from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Visibility, VisibilityOff } from "@material-ui/icons";

import { notifyError, notifySuccess } from "../../utils/js/helpers";
import { Creators as LoginActionCreator } from "../../store/ducks/login";
import "./LoginForm.scss";
import avatar from "../../assets/avatar.png";
import { loginStyle } from "./style.js";
import { MESSAGE_TYPES as msg } from "../../utils/js/constants";

const useStyles = makeStyles((theme) => loginStyle(theme));

const LoginForm = ({ loginFirebase, login }) => {
    const history = useHistory();
    const classes = useStyles();
    const { data, loading, error } = login;
    const [values, setValues] = useState({
        amount: "",
        email: "",
        password: "",
        weight: "",
        weightRange: "",
        showPassword: false,
    });

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        if (data?.message === msg.LOGIN_SUCCESS) {
            history.push("/dashboard");
        }

        if (data?.message === msg.LOGOUT_SUCCESS) {
            notifySuccess('Você foi deslogado com sucesso.');
        }

        if (data?.message === msg.LOGIN_ERROR) {
            notifyError(data.error);
        }
    }, [data, loading, error, history]);

    return (
        <div className="wrapper-login-form">
            <Avatar
                className={classes.avatarLogin}
                alt="Remy Sharp"
                src={avatar}
            />
            <FormControl className={classes.formwrapper}>
                <TextField
                    id="outlined-secondary"
                    label="Email"
                    variant="outlined"
                    color="primary"
                    className={classes.loginForm}
                    onChange={handleChange("email")}
                />
            </FormControl>
            <FormControl className={classes.formwrapper} variant="outlined">
                <InputLabel
                    className={classes.loginForm}
                    htmlFor="outlined-adornment-password"
                >
                    Senha
                </InputLabel>
                <OutlinedInput
                    className={classes.loginForm}
                    id="outlined-adornment-password"
                    type={values.showPassword ? "text" : "password"}
                    value={values.password}
                    onChange={handleChange("password")}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton 
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                                style={{ color: "#FFFB92" }}
                            >
                                {values.showPassword ? (
                                    <Visibility />
                                ) : (
                                    <VisibilityOff />
                                )}
                            </IconButton>
                        </InputAdornment>
                    }
                    labelWidth={70}
                />
            </FormControl>
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <ToastContainer />
            <Button
                className={classes.bottomLogin}
                variant="contained"
                onClick={() => loginFirebase(values.email, values.password)}
            >
                Entrar
            </Button>
        </div>
    );
};

const mapStatetoProps = (state) => ({ ...state });
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(LoginActionCreator, dispatch);
};

export default connect(mapStatetoProps, mapDispatchToProps)(LoginForm);
